/*
 * Copyright (c) Nexign, JSC, 2019.
 */
/**
 *
 *
 * @author Evgenij Tyan
 * @version 1.0.0
 * @since 1.0.0
 */

import {
    SuperSearchBigLoaderStyled,
    SuperSearchListGroupStyled,
    SuperSearchLoaderStubBigStyled,
    SuperSearchLoaderStubSmallStyled,
    SuperSearchSmallLoaderStyled,
} from '../styled/SuperSearchListStyled';

const SuperSearchItemSearch = () => {
    return (
        <SuperSearchListGroupStyled>
            <SuperSearchLoaderStubBigStyled>
                <SuperSearchBigLoaderStyled />
            </SuperSearchLoaderStubBigStyled>
            <SuperSearchLoaderStubSmallStyled>
                <SuperSearchSmallLoaderStyled />
            </SuperSearchLoaderStubSmallStyled>
        </SuperSearchListGroupStyled>
    );
};

export default SuperSearchItemSearch;
